'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reverse2 = require('lodash/reverse');

var _reverse3 = _interopRequireDefault(_reverse2);

var _sortBy2 = require('lodash/sortBy');

var _sortBy3 = _interopRequireDefault(_sortBy2);

exports.default = ordering;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ordering(_ref) {
  var _ref$data = _ref.data,
      data = _ref$data === undefined ? [] : _ref$data,
      activeOrder = _ref.activeOrder,
      order = _ref.order;

  console.time('ordering');
  var sortedArray = (0, _sortBy3.default)(data, activeOrder); // lodash sortBy is extremely faster native Array.sort
  var res = order[activeOrder] === 'asc' ? sortedArray : (0, _reverse3.default)(sortedArray);
  console.timeEnd('ordering');
  return res;
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/utils/ordering.js
// module id = 533
// module chunks = 1